export default __webpack_public_path__ + "static/media/White-LikeIconFocus.8754f9fc.svg";